// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1M7GH","description":"PatientConsentPreview_description__2i3n1"};